import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=8f5bca7c&scoped=true"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=8f5bca7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5bca7c",
  null
  
)

export default component.exports